import React, {
  useContext, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button, CardRounded, CardShowcase, Heading,
  IconDollar, IconFeedback, IconTelephone, Navigation, NavigationItem,
} from '@americanexpress/dls-react';
import { withRouter } from '@americanexpress/one-app-router';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { useDispatch } from 'react-redux';
import Wrapper from '../components/Wrapper';
import CardDetails from '../components/CardDetails';
import { TokenContext } from '../utility/TokenContext';
import useApiWithSession from '../utility/useApiWithSession';
import { PaymentContext } from '../utility/PaymentContext';
import LendingCardSummary from '../components/LendingCardSummary';
import ChargeCardSummary from '../components/ChargeCardSummary';
// import { balData } from '../assets/balData';

const BalancePage = ({ router }) => {
  const { gateWayUrl } = useContext(TokenContext);
  const {
    sid1, market1, journey1, setJourney1, u1, paymentResponse, metaData,
  } = useContext(PaymentContext);
  const dispatch = useDispatch();

  // const paymentResponseDummy = balData.eventData;
  // const { metaData } = balData;

  // START_SESSION event API call
  const {
    isLoading, data, error, run,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'WELCOME_LOAD_OK' },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });
  const {
    isLoading: isLoadingCall, error: errorCall, data: dataCall,
    run: runPhoneCall,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'FINISH_CONTINUE_PHONE' },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });
  const {
    isLoading: isLoadingFinishPayment,
    data: dataFinishPayment,
    error: errorFinishPayment,
    run: runFinishPayment,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'FINISH_PAYMENT' },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });

  const {
    isLoading: isLoadingFinish, data: dataFinish, error: errorFinish, run: runFinish,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'FINISH_OK' },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });

  useEffect(() => {
    const sendWelcomeLoadEvent = async () => {
      try {
        const sessionId = document.cookie
          .split('; ')
          .find((row) => row.startsWith('session_id='))
          ?.split('=')[1];
        if (!sessionId || !paymentResponse) {
          router.push({
            pathname: '/message',
            query: {
              level: 3,
            },
          });
        }

        await run();
      } catch (er) {
        const err = new Error('Load Api call failed');
        dispatch(addErrorToReport(err, { message: 'Loader: API call failed.' }));
      }
    };

    sendWelcomeLoadEvent();
  }, []);

  // Add API call for Rate Your Experience
  const {
    isLoading: isLoadingRate, error: errorRate, data: dataRate, run: runRateExperience,
  } = useApiWithSession({
    url: `${gateWayUrl}/voice/v1/multimodal/events`,
    sid1,
    method: 'PUT',
    body: { eventName: 'FINISH_RATE_EXPERIENCE' },
    customHeaders: {
      session_id: sid1,
      correlation_id: u1,
      consumer: 'GUI',
      market: market1,
      journey: journey1,
    },
  });

  useEffect(() => {
    const pushDummyState = () => {
      window.history.pushState({ noBackEx: true }, '', window.location.href);
    };
    const handlePopState = (event) => {
      pushDummyState();
      event.preventDefault();
    };
    pushDummyState();
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isLoading === false && (error || data?.statusCode === 'failure')) {
      router.push({
        pathname: '/message',
        query: {
          level: 3,
        },
      });
    }
  }, [isLoading]);

  useEffect(() => {
    if (isLoadingFinishPayment === false && (errorFinishPayment || dataFinishPayment?.statusCode === 'failure')) {
      router.push({
        pathname: '/message',
        query: {
          level: 3,
        },
      });
    } else if (isLoadingFinishPayment === false && !errorFinishPayment && dataFinishPayment?.statusCode === 'success') {
      setJourney1('pbp');
      router.push({
        pathname: '/',
      });
    }
  }, [isLoadingFinishPayment]);

  useEffect(() => {
    if (isLoadingCall === false && !errorCall && dataCall?.statusCode === 'success') {
      router.push({
        pathname: '/message',
        query: {
          level: 1,
        },
      });
    } else if (isLoadingCall === false && (errorCall || dataCall?.statusCode === 'failure')) {
      router.push({
        pathname: '/message',
        query: {
          level: 3,
        },
      });
    }
  }, [isLoadingCall]);

  useEffect(() => {
    if (isLoadingFinish === false && (errorFinish || dataFinish?.statusCode === 'failure')) {
      router.push({
        pathname: '/message',
        query: {
          level: 3,
        },
      });
    } else if (isLoadingFinish === false && !errorFinish && dataFinish?.statusCode === 'success') {
      router.push({
        pathname: '/message',
        query: {
          level: 1,
        },
      });
    }
  }, [isLoadingFinish]);

  // Handle redirect after Rate Experience event
  useEffect(() => {
    if (isLoadingRate === false && !errorRate && dataRate?.statusCode === 'success') {
      router.push({
        pathname: '/feedback',
      });
    } else if (isLoadingRate === false && (errorRate || dataRate?.statusCode === 'failure')) {
      router.push({
        pathname: '/message',
        query: {
          level: 3,
        },
      });
    }
  }, [isLoadingRate]);

  const phoneCall = async () => {
    try {
      const sessionId = document.cookie
        .split('; ')
        .find((row) => row.startsWith('session_id='))
        ?.split('=')[1];

      if (!sessionId) {
        console.error('Session ID is missing.');
        return;
      }

      await runPhoneCall();
    } catch (er) {
      console.error('Error sending FINISH_CONTINUE_PHONE event:', er);
    }
  };

  const redirectToPayment = async () => {
    await runFinishPayment();
  };

  const handleFinish = async () => {
    try {
      const sessionId = document.cookie
        .split('; ')
        .find((row) => row.startsWith('session_id='))
        ?.split('=')[1];

      if (!sessionId) {
        console.error('Session ID is missing.');
        return;
      }

      await runFinish();
    } catch (err) {
      console.error('Error making FINISH_OK API call:', err);
    }
  };

  function formatAmount(amount) {
    if (amount === null || amount === undefined || Number.isNaN(amount)) return '--';
    return `$${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Helper: Parse date string as local midnight if in YYYY-MM-DD format, and return
  // formatted string
  const parseLocalDate = (dateStr) => {
    if (!dateStr) return '';
    let dateObj;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      dateObj = new Date(`${dateStr}T00:00:00`);
    } else {
      dateObj = new Date(dateStr);
    }
    if (Number.isNaN(dateObj.getTime())) return '';
    return dateObj.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
  };
    // Find the first remittance with status not 'ACTIVE'
  const nonActiveRemittance = Array.isArray(paymentResponse?.paymentHistory?.remittances)
    ? paymentResponse.paymentHistory.remittances.find((r) => r.status !== 'ACTIVE')
    : undefined;
    // Check if its status is 'PROCESSING'
  const isProcessingStatus = nonActiveRemittance?.status === 'PROCESSING';

  // Find the first 'IMMEDIATE' payment
  const immediateRemittance = Array.isArray(paymentResponse?.paymentHistory?.remittances)
    ? paymentResponse.paymentHistory.remittances.find((r) => r.frequency === 'IMMEDIATE')
    : undefined;
    // Check if paymentDate is within 45 days from today
  let isImmediateWithin45Days = false;
  if (immediateRemittance?.paymentDate) {
    const paymentDateObj = new Date(immediateRemittance.paymentDate);
    const today = new Date();
    const diffDays = (today - paymentDateObj) / (1000 * 60 * 60 * 24);
    isImmediateWithin45Days = diffDays <= 45 && diffDays >= 0;
  }

  // Only show More Details if either condition is true
  const showMoreDetails = isProcessingStatus || isImmediateWithin45Days;

  return (
    <div>
      <Wrapper>
        <div className="margin-4-t margin-2-b">
          <Heading level={4} headingStyle="heading4" style={{ fontWeight: 500 }} className="text-align-center">
            {paymentResponse?.productInfo?.product_desc}
          </Heading>
          <p className="label-1 text-align-center">{paymentResponse?.productInfo?.display_account_number}</p>
        </div>
        <CardDetails imageSource={paymentResponse?.productInfo?.digital_asset_url || '/assets/card-placeholder.png'} />
        <CardShowcase className="anim-fade-in anim-delay-1 width-full pad-1 card-rounded">
          <div className="pad-1-lr pad-2-tb card-rounded">
            <div className="flex flex-column flex-align-start" style={{ gap: '10px' }}>
              <Heading
                level={4}
                headingStyle="heading4"
                style={{ fontWeight: 700 }}
              >
                Balance Summary
              </Heading>
              {metaData?.GBL_API_PMC_paymentType === 'Charge' ? (
                <ChargeCardSummary
                  metaData={metaData}
                  realTimeBalance={paymentResponse?.realTimeBalance}
                  globalLimits={paymentResponse?.globalLimits}
                  paymentHistory={paymentResponse?.paymentHistory}
                  statementPeriods={paymentResponse?.statementPeriods}
                  planSummary={paymentResponse?.planSummary}
                />
              ) : (
                <LendingCardSummary
                  metaData={metaData}
                  realTimeBalance={paymentResponse?.realTimeBalance}
                  planSummary={paymentResponse?.planSummary}
                  globalLimits={paymentResponse?.globalLimits}
                />
              )}
              {showMoreDetails ? (
                <Navigation
                  defaultOpenPanelIds={['last-payment-details']}
                  shouldAllowMultipleExpanded={true}
                  showInContainer={true}
                  className="width-full"
                >
                  <NavigationItem id="last-payment-details" label="More Details">
                    <div className="flex flex-justify-between width-full">
                      <p className="body-3 dls-gray-06 text-align-left">Last Payment Amount:</p>
                      <p className="body-3">{formatAmount(isProcessingStatus ? nonActiveRemittance?.amount : immediateRemittance?.amount)}</p>
                    </div>
                    <div className="flex flex-justify-between width-full">
                      <p className="body-3 dls-gray-06 text-align-left">Last Payment Date:</p>
                      <p className="body-3">{parseLocalDate(isProcessingStatus ? nonActiveRemittance?.paymentDate : immediateRemittance?.paymentDate)}</p>
                    </div>
                    <div className="flex flex-justify-between width-full">
                      <p className="body-3 dls-gray-06 text-align-left">Next Statement Date:</p>
                      <p className="body-3">{parseLocalDate(paymentResponse?.statementPeriods.currentClosingDate)}</p>
                    </div>
                  </NavigationItem>
                </Navigation>
              ) : null}
            </div>
          </div>
        </CardShowcase>
      </Wrapper>
      <div className="width-full pad-1">
        <Button
          type="button"
          className="width-full"
          styleType="primary"
          style={{ maxWidth: '100%' }}
          onClick={handleFinish}
        >
          <p className="heading-4">Done</p>
        </Button>
      </div>
      <Heading
        level={4}
        headingStyle="heading3"
        className="pad-1-lr"
      >Helpful links
      </Heading>
      <CardRounded className="anim-fade-in anim-delay-1 width-full pad-1 card-rounded">
        <div className="text-align-left">
          <div className="flex width-full pad-1">
            <IconDollar
              title="Example icon"
              titleId="example-icon-id"
              size="sm"
            />
            <div className="text-align-left margin-1-l body-3"><button onClick={redirectToPayment} type="button" className="text-link link-underlined" style={{ textDecoration: 'underline' }}><span>Make a Payment</span></button></div>
          </div>
          <hr />
          <div className="flex width-full pad-1">
            <IconTelephone
              title="Example icon"
              titleId="example-icon-id"
              size="sm"
            />
            <button type="button" className="text-link link-underlined text-align-left margin-1-l body-3" style={{ textDecoration: 'underline' }} onClick={phoneCall}><span>Continue on Phone</span></button>
          </div>
        </div>
      </CardRounded>
      <div className="flex pad-1-lr">
        <IconFeedback
          filled={true}
          title="Example icon"
          titleId="example-icon-id"
          className="dls-bright-blue"
        />
        <p
          className="pad-1-lr body-1"
        >We’d love to hear from you.
        </p>
      </div>
      <CardRounded className="anim-fade-in anim-delay-1 width-full pad-1 card-rounded">
        <button
          type="button"
          className="text-link link-underlined pad-1 text-align-left card-rounded"
          style={{ textDecoration: 'underline' }}
          onClick={runRateExperience}
        >
          <span>Rate Your Experience</span>
        </button>
      </CardRounded>
    </div>
  );
};

BalancePage.propTypes = {
  router: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.shape({
    query: PropTypes.instanceOf(Object),
  }).isRequired,
};

export default withRouter(BalancePage);
